import React, { useEffect } from "react";
import { Button } from "reactstrap";

const ScrolltoTop = () => {
  useEffect(() => {
    const onScroll = () => {
      const mybutton = document.getElementById("back-to-top");
      // Guard: the button only exists on pages that render this component.
      if (!mybutton) return;
      const scrolled =
        document.body.scrollTop > 20 || document.documentElement.scrollTop > 20;
      mybutton.style.display = scrolled ? "block" : "none";
    };
    // Use a scoped listener that is removed on unmount, instead of assigning a
    // global window.onscroll that leaks across route changes and throws on
    // pages without the button.
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <Button id="back-to-top" className="p-0" onClick={scrollTop}>
      <i className="mdi mdi-arrow-up"></i>
    </Button>
  );
};

export default ScrolltoTop;
